import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_position_entry_hire = () => {
  useAuthRedirect();
  const { sno } = useParams();
  const navigate = useNavigate();
  const userId = localStorage.getItem("username");
   const canEntry = hasPermission("Vehicle Closing List", "entry");

  const [hireclosing, setHireClosing] = useState({});
  const [formData, setFormData] = useState({
    vehicle_basis: "",
    driver: "",
    remarks: "",
  });

  useEffect(() => {
    const fetchHireClosing = async () => {
      if (!sno) return;
      try {
        Swal.fire({
                            title: "Fetching Vehicle Details",
                            html: `
                                <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                                <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                                </div>
                                <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Vehicle Details...</p>
                            `,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            didOpen: () => {
                                const style = document.createElement("style");
                                style.innerHTML = `
                                @keyframes progressBar {
                                    0% { width: 0% }
                                    50% { width: 100% }
                                    100% { width: 0% }
                                }
                                `;
                                document.head.appendChild(style);
                            },
                            });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/hire_vehicle_closing_details?sno=${sno}`);
        if (response.data && response.data.closingHire?.length > 0) {
          const items = response.data.closingHire;

          const closingHireDetail = {
            vcode: items[0].fld_vcode,
            vnumber: items[0].fld_vehno,
            vname: items[0].fld_vname,
            vtype: items[0].fld_vtype,
            vehicleBranch: items[0].branch_code,
            owner: items[0].fld_ownersname,
            company: items[0].fld_vcompanyname,
          };

          setHireClosing(closingHireDetail);
        } else {
          console.warn("API Response does not contain expected data structure");
        }
        Swal.close();
      } catch (error) {
         Swal.close();
                        console.error("Error fetching Vehicle Details. Please try again:", error);
                        Swal.fire({ 
                        icon: "error",
                        title: "Oops!",
                        text: "Error fetching Vehicle Details. Please try again",
                        });
      }
    };
{canEntry && (
    fetchHireClosing()
)}
  }, [sno]);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      vcode: hireclosing.vcode,
      vehno: hireclosing.vnumber,
      vbranch: hireclosing.vehicleBranch,
      remarks: formData.remarks,
      vname: hireclosing.vname,
      user: userId,
      slNo: sno,
    };

    console.log("Submitting Payload:", payload);

    try {
         Swal.fire({
                                        title: "Submitting...",
                                        text: "Please wait while we process your request.",
                                        allowOutsideClick: false,
                                        didOpen: () => {
                                          Swal.showLoading();
                                        },
                                      });
          
      const response = await axios.put("https://rfs2.infraconsoft.net.in/api/hire_closing_insert", payload);

      if (!response.data.success) {
        // Show error if bill is pending
        Swal.fire({
          icon: "error",
          title: "Cannot Close Vehicle",
          text: response.data.message,
        });
      } else {
        // Show success message
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Vehicle Closed successfully.",
          confirmButtonText: "OK",
        }).then(() => {
          navigate(`/hire_vehicle_list`);
        });
      }
    } catch (error) {
  console.error("Error submitting form:", error);

  let errorMessage = "An error occurred while closing the vehicle. Please try again.";

  // Check if the server responded with a custom error
  if (error.response && error.response.data) {
    const { error: serverError, stack } = error.response.data;
    errorMessage = serverError || errorMessage;

    console.error("🔴 Backend Error Message:", serverError);
    console.error("🔴 Backend Stack:", stack);
  }

  Swal.fire({
    icon: "error",
    title: "Submission Failed",
    html: `<pre style="text-align:left;">${errorMessage}</pre>`,
    confirmButtonText: "OK"
  });
}

  };

  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
        <div className="back-div">
          <h2 className="add-txt">Hire Vehicle Closing Form</h2>
          <Link to='/hire_vehicle_list'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
        </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="vcode" value={hireclosing.vcode} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text" value={new Date().toLocaleDateString("en-GB")} readOnly={true} />
              </div>
            </div>

  
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input
  type="text"
  name="vname"
  value={hireclosing.vname?.trim() || ""} 
  readOnly
/>
              </div>
             
            

              <div className="form-group">
                <label>Vehicle Number :</label>
                <input type="text" name="vehno" value={hireclosing.vnumber} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Owner Name :</label>
                <input type="text" name="branch" value={hireclosing.owner} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Company Name :</label>
                <input type="text" name="branch" value={hireclosing.company} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Type :</label>
                <input type="text" name="branch" value={hireclosing.vtype} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Vehicle Status :</label>
                <input type="text" name="driver" value="Hire" onChange={handleChange} readOnly={true} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch Name :</label>
                <input type="text" name="branch" value={hireclosing.vehicleBranch} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Reason For Closing :</label>
                <input type="text" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_position_entry_hire;
